const monsters = [
  {
    name: "Snail",
    map: "Thicket Around the Beach III",
    town: "Lith Harbor",
    tour_order: 1,
  },
  {
    name: "Blue Snail",
    map: "Right Around Lith Harbor",
    town: "Lith Harbor",
    tour_order: 0,
  },
  {
    name: "Shroom",
    map: "Mushroom Garden",
    town: "Henesys",
    tour_order: 2,
  },
  {
    name: "Stump",
    map: "The Tree That Grew III",
    town: "Ellinia",
    tour_order: 17,
  },
  {
    name: "Red Snail",
    map: "West Rocky Mountain I",
    town: "Perion",
    tour_order: 18,
  },
  {
    name: "Slime",
    map: "The Tree That Grew II",
    town: "Ellinia",
    tour_order: 16,
  },
  {
    name: "Pig",
    map: "Henesys Pig Farm",
    town: "Henesys",
    tour_order: 3,
  },
  {
    name: "Orange Mushroom",
    map: "Mushroom Garden",
    town: "Henesys",
    tour_order: 2,
  },
  {
    name: "Dark Stump",
    map: "East Rocky Mountain II",
    town: "Perion",
    tour_order: 23,
  },
  {
    name: "Ribbon Pig",
    map: "Henesys Pig Farm",
    town: "Henesys",
    tour_order: 3,
  },
  {
    name: "Octopus",
    map: "Damp Forest",
    town: "Sleepywood",
    tour_order: 56,
  },
  {
    name: "Green Mushroom",
    map: "Tree Dungeon, Forest Up North VI",
    town: "Ellinia",
    tour_order: 12,
  },
  {
    name: "Bubbling",
    map: "Line 1 <Area 1>",
    town: "Kerning City",
    tour_order: 44,
  },
  {
    name: "Axe Stump",
    map: "East Rocky Mountain III",
    town: "Perion",
    tour_order: 24,
  },
  {
    name: "Ghost Stump",
    map: "Excavation Site I",
    town: "Perion",
    tour_order: 29,
  },
  {
    name: "Blue Mushroom",
    map: "The Blue Mushroom Forest",
    town: "Henesys",
    tour_order: 4,
  },
  {
    name: "Stirge",
    map: "Transfer Area",
    town: "Kerning City",
    tour_order: 45,
  },
  {
    name: "Desert Rabbit (F)",
    map: "Outside East Entrance of Ariant",
    town: "Ariant",
    tour_order: 260,
  },
  {
    name: "Desert Rabbit (M)",
    map: "Tent of the Entertainers",
    town: "Ariant",
    tour_order: 259,
  },
  {
    name: "Jr. Necki",
    map: "Damp Forest",
    town: "Sleepywood",
    tour_order: 56,
  },
  {
    name: "Horny Mushroom",
    map: "Ant Tunnel IV",
    town: "Sleepywood",
    tour_order: 58,
  },
  {
    name: "Dark Axe Stump",
    map: "East Rocky Mountain V",
    town: "Perion",
    tour_order: 26,
  },
  {
    name: "Pinboom",
    map: "The Sharp Unknown",
    town: "Aquarium",
    tour_order: 147,
  },
  {
    name: "Jr. Cactus",
    map: "Outside the West Entrance of Ariant",
    town: "Ariant",
    tour_order: 249,
  },
  {
    name: "Trixter",
    map: "Eos Tower 73rd Floor",
    town: "Ludibrium",
    tour_order: 217,
  },
  {
    name: "Jr. Sentinel",
    map: "Orbis Tower <20th Floor>",
    town: "Orbis",
    tour_order: 94,
  },
  {
    name: "Seacle",
    map: "Fish Resting Spot",
    town: "Aquarium",
    tour_order: 145,
  },
  {
    name: "Wooden Mask",
    map: "Excavation Site II",
    town: "Perion",
    tour_order: 30,
  },
  {
    name: "Bellamoa",
    map: "Bellamoa's Cave",
    town: "Ariant",
    tour_order: 255,
  },
  {
    name: "Zombie Mushroom",
    map: "Ant Tunnel III",
    town: "Sleepywood",
    tour_order: 57,
  },
  {
    name: "Krappy",
    map: "Mushroom Coral Hill",
    town: "Aquarium",
    tour_order: 146,
  },
  {
    name: "Rocky Mask",
    map: "Excavation Site III",
    town: "Perion",
    tour_order: 31,
  },
  {
    name: "Ear Plug Plead",
    map: "The Scorching Desert",
    town: "Ariant",
    tour_order: 256,
  },
  {
    name: "Sand Rat",
    map: "Hill of Sandstorms",
    town: "Ariant",
    tour_order: 267,
  },
  {
    name: "Cico",
    map: "Fish Resting Spot",
    town: "Aquarium",
    tour_order: 145,
  },
  {
    name: "Wild Boar",
    map: "The Land of Wild Boar II",
    town: "Perion",
    tour_order: 28,
  },
  {
    name: "Cactus",
    map: "Cactus Desert 1",
    town: "Ariant",
    tour_order: 251,
  },
  {
    name: "Evil Eye",
    map: "The Cave of Evil Eye III",
    town: "Sleepywood",
    tour_order: 61,
  },
  {
    name: "Scarf Plead",
    map: "Frilled Field",
    town: "Ariant",
    tour_order: 258,
  },
  {
    name: "Bubble Fish",
    map: "Big Fish Valley",
    town: "Aquarium",
    tour_order: 143,
  },
  {
    name: "Green Trixter",
    map: "Eos Tower 71st Floor",
    town: "Ludibrium",
    tour_order: 218,
  },
  {
    name: "Royal Cactus",
    map: "Royal Cactus Desert",
    town: "Ariant",
    tour_order: 253,
  },
  {
    name: "Flower Fish",
    map: "Sand Castle Playground",
    town: "Aquarium",
    tour_order: 142,
  },
  {
    name: "Meercat",
    map: "Outside North Entrance of Ariant",
    town: "Ariant",
    tour_order: 261,
  },
  {
    name: "Scorpion",
    map: "Sahel 1",
    town: "Magatia",
    tour_order: 263,
  },
  {
    name: "Sentinel",
    map: "Orbis Tower <15th Floor>",
    town: "Orbis",
    tour_order: 97,
  },
  {
    name: "Fairy 1",
    map:
      '"Golem\'s Temple IV", "The Breathing Rock", "Tree Dungeon, Forest Up North IV", "Someone Else\'s House"',
    town: "",
    tour_order: 999,
  },
  {
    name: "Brown Teddy",
    map: "Terrace Hall",
    town: "Ludibrium",
    tour_order: 174,
  },
  {
    name: "Krip",
    map: "The Seaweed Tower",
    town: "Aquarium",
    tour_order: 140,
  },
  {
    name: "Kiyo",
    map: "North Desert Road 2",
    town: "Magatia",
    tour_order: 271,
  },
  {
    name: "Ice Sentinel",
    map: "Orbis Tower <13th Floor>",
    town: "Orbis",
    tour_order: 98,
  },
  {
    name: "Fire Sentinel",
    map: "Orbis Tower <11th Floor>",
    town: "Orbis",
    tour_order: 99,
  },
  {
    name: "Biner",
    map: "Central Way 1",
    town: "CBD",
    tour_order: 370,
  },
  {
    name: "Batoo",
    map: "Central Way 3",
    town: "CBD",
    tour_order: 372,
  },
  {
    name: "Stopnow",
    map: "Central Way 1",
    town: "CBD",
    tour_order: 370,
  },
  {
    name: "Crow",
    map: "Crow Forest 2",
    town: "Mushroom Shrine",
    tour_order: 406,
  },
  {
    name: "Fire Raccoon",
    map: "Forest of Animals",
    town: "Mushroom Shrine",
    tour_order: 415,
  },
  {
    name: "Cloud Fox",
    map: "The Mountain of Cloud Fox",
    town: "Mushroom Shrine",
    tour_order: 405,
  },
  {
    name: "Genin",
    map: "Ninja Castle Hallway [1]",
    town: "Ninja Castle",
    tour_order: 426,
  },
  {
    name: "Ashigaru",
    map: "Ninja Castle Hallway [2]",
    town: "Ninja Castle",
    tour_order: 427,
  },
  {
    name: "Rooster",
    map: "Shanghai - Out of the Bridge",
    town: "Shanghai",
    tour_order: 999,
  },
  {
    name: "Duck",
    map: "Shanghai - Out of the Bridge",
    town: "Shanghai",
    tour_order: 999,
  },
  {
    name: "Sheep",
    map: "Shanghai - Northern Park",
    town: "Shanghai",
    tour_order: 999,
  },
  {
    name: "Goat",
    map: "Mountainous Region II",
    town: "Shanghai",
    tour_order: 447,
  },
  {
    name: "Chirppy",
    map: "Eos Tower 92nd Floor",
    town: "Ludibrium",
    tour_order: 214,
  },
  {
    name: "Drumming Bunny",
    map: "Drummer Bunny's Lair",
    town: "Ludibrium",
    tour_order: 216,
  },
  {
    name: "Ligator",
    map: "The Swamp of Despair III",
    town: "Kerning City",
    tour_order: 52,
  },
  {
    name: "Fire Boar",
    map: "The Burnt Land III",
    town: "Perion",
    tour_order: 41,
  },
  {
    name: "Pink Teddy",
    map: "Cloud Terrace<2>",
    town: "Ludibrium",
    tour_order: 180,
  },
  {
    name: "Ratz",
    map: "Eos Tower 1st Floor",
    town: "Omega Sector",
    tour_order: 222,
  },
  {
    name: "Leatty",
    map: "Orbis Tower <7th Floor>",
    town: "El Nath",
    tour_order: 103,
  },
  {
    name: "Mask Fish",
    map: "Forked Road : East Sea",
    town: "Aquarium",
    tour_order: 139,
  },
  {
    name: "Sand Dwarf",
    map: "The Ruins of Desert Nomads",
    town: "Magatia",
    tour_order: 268,
  },
  {
    name: "Cube Slime",
    map: "Lab - Unit 101",
    town: "Magatia",
    tour_order: 272,
  },
  {
    name: "Dark Sand Dwarf",
    map: "The Desert of Dreams",
    town: "Magatia",
    tour_order: 265,
  },
  {
    name: "Jr. Cellion",
    map: "Garden of Red I",
    town: "Orbis",
    tour_order: 84,
  },
  {
    name: "Jr. Lioner",
    map: "Garden of Yellow I",
    town: "Orbis",
    tour_order: 86,
  },
  {
    name: "Jr. Grupin",
    map: "Garden of Green I",
    town: "Orbis",
    tour_order: 88,
  },
  {
    name: "Dark Leatty",
    map: "Orbis Tower <3rd Floor>",
    town: "El Nath",
    tour_order: 102,
  },
  {
    name: "Roloduck",
    map: "Sky Terrace<5>",
    town: "Ludibrium",
    tour_order: 179,
  },
  {
    name: "Black Ratz",
    map: "Eos Tower 3rd Floor",
    town: "Omega Sector",
    tour_order: 217,
  },
  {
    name: "Tick",
    map: "Crossroad of Time",
    town: "Ludibrium",
    tour_order: 188,
  },
  {
    name: "Curse Eye",
    map: "Tree Dungeon, Forest Up North IX",
    town: "Ellinia",
    tour_order: 13,
  },
  {
    name: "Jr. Wraith",
    map: "Line 2 <Area 1>",
    town: "Kerning City",
    tour_order: 48,
  },
  {
    name: "Star Pixie",
    map: "Cloud Park I",
    town: "Orbis",
    tour_order: 76,
  },
  {
    name: "Jr. Boogie 1",
    map: "The Grave of Mushmom",
    town: "Sleepywood",
    tour_order: 59,
  },
  {
    name: "Bloctopus",
    map: "Eos Tower 41st Floor",
    town: "Omega Sector",
    tour_order: 229,
  },
  {
    name: "Jr. Pepe",
    map: "Orbis Tower <1st Floor>",
    town: "El Nath",
    tour_order: 101,
  },
  {
    name: "Rumo",
    map: "Lab - Unit 102",
    town: "Magatia",
    tour_order: 273,
  },
  {
    name: "Panda Teddy",
    map: "Toy Factory <Main Process 2>",
    town: "Ludibrium",
    tour_order: 187,
  },
  {
    name: "Helly",
    map: "Eos Tower 60th Floor",
    town: "Ludibrium",
    tour_order: 223,
  },
  {
    name: "Scuba Pepe",
    map: "Orbis Tower<B2>",
    town: "El Nath",
    tour_order: 104,
  },
  {
    name: "Retz",
    map: "Helios Tower (100th Floor)",
    town: "Ludibrium",
    tour_order: 173,
  },
  {
    name: "Lupin",
    map: "Downstairs at the Forest",
    town: "Ellinia",
    tour_order: 11,
  },
  {
    name: "Lorang",
    map: "Lorang Lorang",
    town: "Florina Beach",
    tour_order: 72,
  },
  {
    name: "Propelly",
    map: "Eos Tower 58th Floor",
    town: "Ludibrium",
    tour_order: 220,
  },
  {
    name: "Chronos",
    map: "The Path of Time <2>",
    town: "Ludibrium",
    tour_order: 191,
  },
  {
    name: "King Bloctopus",
    map: "Eos Tower 22nd Floor",
    town: "Omega Sector",
    tour_order: 226,
  },
  {
    name: "Planey",
    map: "Eos Tower 25th Floor",
    town: "Omega Sector",
    tour_order: 228,
  },
  {
    name: "Jr. Seal",
    map: "Crystal Gorge",
    town: "Aquarium",
    tour_order: 136,
  },
  {
    name: "Triple Rumo",
    map: "Lab - Unit 103",
    town: "Magatia",
    tour_order: 274,
  },
  {
    name: "Tweeter",
    map: "Eos Tower 6th Floor",
    town: "Omega Sector",
    tour_order: 223,
  },
  {
    name: "Toy Trojan",
    map: "Cloud Terrace<5>",
    town: "Ludibrium",
    tour_order: 181,
  },
  {
    name: "Cold Eye",
    map: "Sanctuary Entrance I",
    town: "Sleepywood",
    tour_order: 67,
  },
  {
    name: "Zombie Lupin",
    map: "Monkey Swamp III",
    town: "Kerning City",
    tour_order: 55,
  },
  {
    name: "Tick-Tock",
    map: "Whirlpool of Time",
    town: "Ludibrium",
    tour_order: 193,
  },
  {
    name: "Barnard Gray",
    map: "Kulan Field I",
    town: "Omega Sector",
    tour_order: 242,
  },
  {
    name: "Poopa",
    map: "Ocean I.C",
    town: "Aquarium",
    tour_order: 137,
  },
  {
    name: "Poison Poopa",
    map: "Crystal Gorge",
    town: "Aquarium",
    tour_order: 136,
  },
  {
    name: "Chipmunk",
    map: "Entrance to Sky Forest",
    town: "Mu Lung",
    tour_order: 291,
  },
  {
    name: "Desert Giant",
    map: "The Giant of the Sunset",
    town: "Magatia",
    tour_order: 269,
  },
  {
    name: "Flyeye",
    map: "The Dangerous Cave",
    town: "Aquarium",
    tour_order: 153,
  },
  {
    name: "Robo",
    map: "Toy Factory <Process 2> Zone 2",
    town: "Ludibrium",
    tour_order: 186,
  },
  {
    name: "Platoon Chronos",
    map: "Lost Time <1>",
    town: "Ludibrium",
    tour_order: 194,
  },
  {
    name: "Mateon",
    map: "Off-Limits",
    town: "Omega Sector",
    tour_order: 231,
  },
  {
    name: "Red Porky",
    map: "Sky Forest : The Train",
    town: "Mu Lung",
    tour_order: 292,
  },
  {
    name: "Nependeath",
    map: "Disposed Flower Garden",
    town: "Orbis",
    tour_order: 79,
  },
  {
    name: "Iron Hog",
    map: "Pig Park II",
    town: "Henesys",
    tour_order: 5,
  },
  {
    name: "Block Golem",
    map: "Hidden Tower",
    town: "Omega Sector",
    tour_order: 224,
  },
  {
    name: "Zeta Gray",
    map: "Kulan Field III",
    town: "Omega Sector",
    tour_order: 244,
  },
  {
    name: "Freezer",
    map: "Red Coral Forest",
    town: "Aquarium",
    tour_order: 135,
  },
  {
    name: "Iron Mutae",
    map: "Lab - Area B-3",
    town: "Magatia",
    tour_order: 278,
  },
  {
    name: "Jr. Cerebes",
    map: "Cave Within the Cave",
    town: "El Nath",
    tour_order: 131,
  },
  {
    name: "Sparker",
    map: "Turban Shell Hill",
    town: "Aquarium",
    tour_order: 134,
  },
  {
    name: "Black Porky",
    map: "Deep in the Sky Forest",
    town: "Mu Lung",
    tour_order: 293,
  },
  {
    name: "Plateon",
    map: "Boswell Field II",
    town: "Omega Sector",
    tour_order: 233,
  },
  {
    name: "Master Robo",
    map: "Toy Factory <Process 2> Zone 1",
    town: "Ludibrium",
    tour_order: 185,
  },
  {
    name: "Skeledog",
    map: "Remains <Tomb> I",
    town: "Perion",
    tour_order: 32,
  },
  {
    name: "Lunar Pixie",
    map: "Cloud Park IV",
    town: "Orbis",
    tour_order: 80,
  },
  {
    name: "Copper Drake",
    map: "East Rocky Mountain VII",
    town: "Perion",
    tour_order: 27,
  },
  {
    name: "King Block Golem",
    map: "Hidden Tower",
    town: "Omega Sector",
    tour_order: 224,
  },
  {
    name: "Ultra Gray",
    map: "Kulan Field V",
    town: "Omega Sector",
    tour_order: 248,
  },
  {
    name: "Moon Bunny",
    map: "Entrance to Black Mountain",
    town: "Korean Folk Town",
    tour_order: 155,
  },
  {
    name: "Iron Boar",
    map: "Iron Boar Land",
    town: "Perion",
    tour_order: 21,
  },
  {
    name: "Blue Flower Serpent",
    map: "Snake Area",
    town: "Mu Lung",
    tour_order: 294,
  },
  {
    name: "Red Flower Serpent",
    map: "Where the Sky Forest Ends",
    town: "Mu Lung",
    tour_order: 299,
  },
  {
    name: "Reinforced Iron Mutae",
    map: "Lab - Area A-3",
    town: "Magatia",
    tour_order: 279,
  },
  {
    name: "Mossy Snail",
    map: "Mossy Tree Forest Entrance",
    town: "Altaire Camp",
    tour_order: 166,
  },
  {
    name: "Nospeed",
    map: "Central Way 3",
    town: "CBD",
    tour_order: 372,
  },
  {
    name: "Freezer",
    map: "Suburban Area 1",
    town: "Aquarium",
    tour_order: 373,
  },
  {
    name: "Octobunny",
    map: "Mysterious Path 2",
    town: "Boat Quay Town",
    tour_order: 386,
  },
  {
    name: "Chlorotrap",
    map: "Outskirts of Muddy Banks",
    town: "Trend Zone Metropolis",
    tour_order: 393,
  },
  {
    name: "Big Cloud Fox",
    map: "A Desolate Cemetery",
    town: "Mushroom Shrine",
    tour_order: 411,
  },
  {
    name: "Paper Lantern Ghost",
    map: "A Night in the Forest",
    town: "Mushroom Shrine",
    tour_order: 408,
  },
  {
    name: "Extra A",
    map: "Showa Street 1",
    town: "Showa",
    tour_order: 416,
  },
  {
    name: "Black Goat",
    map: "Mountainous Region II",
    town: "Shanghai",
    tour_order: 447,
  },
  {
    name: "Cow",
    map: "Western Prairie II",
    town: "Shanghai",
    tour_order: 382,
  },
  {
    name: "Plow Ox",
    map: "Western Prairie III",
    town: "Shanghai",
    tour_order: 382,
  },
  {
    name: "Black Sheep",
    map: "The Land of Black Sheep",
    town: "Shanghai",
    tour_order: 152,
  },
  {
    name: "Mecateon",
    map: "Boswell Field VI",
    town: "Omega Sector",
    tour_order: 240,
  },
  {
    name: "Tortie",
    map: "Hot Sand",
    town: "Florina Beach",
    tour_order: 75,
  },
  {
    name: "Master Chronos",
    map: "Lost Time <2>",
    town: "Ludibrium",
    tour_order: 195,
  },
  {
    name: "Dark Nependeath",
    map: "Disposed Flower Garden",
    town: "Orbis",
    tour_order: 79,
  },
  {
    name: "Rombot",
    map: "Hidden Tower",
    town: "Omega Sector",
    tour_order: 224,
  },
  {
    name: "Mummydog",
    map: "Remains <Tomb> III",
    town: "Perion",
    tour_order: 34,
  },
  {
    name: "Jar",
    map: "10-Year-Old Herb Garden",
    town: "Herb Town",
    tour_order: 307,
  },
  {
    name: "Mithril Mutae",
    map: "Lab - Area B-1",
    town: "Magatia",
    tour_order: 284,
  },
  {
    name: "Wraith",
    map: "Line 2 <Area 3>",
    town: "Kerning City",
    tour_order: 49,
  },
  {
    name: "Clang",
    map: "Clang and Lorang",
    town: "Florina Beach",
    tour_order: 74,
  },
  {
    name: "Ginseng Jar",
    map: "50-Year-Old Herb Garden",
    town: "Herb Town",
    tour_order: 308,
  },
  {
    name: "Chief Gray",
    map: "Barnard Field",
    town: "Omega Sector",
    tour_order: 245,
  },
  {
    name: "Drake",
    map: "Drake Hunting Ground",
    town: "Sleepywood",
    tour_order: 62,
  },
  {
    name: "Jr. Yeti",
    map: "Watch Out for Icy Path I",
    town: "El Nath",
    tour_order: 105,
  },
  {
    name: "Hodori",
    map: "Around the Pond",
    town: "Korean Folk Town",
    tour_order: 157,
  },
  {
    name: "Straw Target Dummy",
    map: "Practice Field : Beginner",
    town: "Mu Lung",
    tour_order: 287,
  },
  {
    name: "Reinforced Mithril Mutae",
    map: "Lab - Area A-1",
    town: "Magatia",
    tour_order: 285,
  },
  {
    name: "Firebomb",
    map: '"The Secret Spa (M)", "The Secret Spa (F)"',
    town: "Showa",
    tour_order: 419,
  },
  {
    name: "Wooden Target Dummy",
    map: "Practice Field : Advanced Level",
    town: "Mu Lung",
    tour_order: 290,
  },
  {
    name: "Croco",
    map: "Dangerous Croko I",
    town: "Kerning City",
    tour_order: 53,
  },
  {
    name: "Luster Pixie",
    map: "Cloud Park VI",
    town: "Orbis",
    tour_order: 82,
  },
  {
    name: "Cellion",
    map: "Garden of Red II",
    town: "Orbis",
    tour_order: 85,
  },
  {
    name: "Lioner",
    map: "Garden of Yellow II",
    town: "Orbis",
    tour_order: 87,
  },
  {
    name: "Grupin",
    map: "Garden of Green II",
    town: "Orbis",
    tour_order: 89,
  },
  {
    name: "Hogul",
    map: "The Area of Wild Hog",
    town: "Korean Folk Town",
    tour_order: 159,
  },
  {
    name: "Bellflower Root",
    map: "60-Year-Old Herb Garden",
    town: "Herb Town",
    tour_order: 309,
  },
  {
    name: "MT-09",
    map: "Defeat Monsters",
    town: "Omega Sector",
    tour_order: 241,
  },
  {
    name: "Sr. Bellflower Root",
    map: "Bellflower Valley",
    town: "Herb Town",
    tour_order: 312,
  },
  {
    name: "Roid",
    map: "Lab - Area C-1",
    town: "Magatia",
    tour_order: 283,
  },
  {
    name: "Malady",
    map: "The Forest of Evil II",
    town: "Ellinia",
    tour_order: 15,
  },
  {
    name: "Stone Golem",
    map: "Golem's Temple I",
    town: "Henesys",
    tour_order: 7,
  },
  {
    name: "Hector",
    map: "Cold Field I",
    town: "El Nath",
    tour_order: 106,
  },
  {
    name: "The Book Ghost",
    map: "Virtuous Forest",
    town: "Mu Lung",
    tour_order: 302,
  },
  {
    name: "Dark Jr. Yeti",
    map: "Sharp Cliff II",
    town: "El Nath",
    tour_order: 114,
  },
  {
    name: "Samiho",
    map: "Moon Ridge",
    town: "Korean Folk Town",
    tour_order: 162,
  },
  {
    name: "Grizzly",
    map: "Wild Bear Area 1",
    town: "Mu Lung",
    tour_order: 295,
  },
  {
    name: "Skeleton Soldier",
    map: "Camp 1",
    town: "Perion",
    tour_order: 33,
  },
  {
    name: "Coolie Zombie",
    map: "Forest of Dead Trees II",
    town: "El Nath",
    tour_order: 122,
  },
  {
    name: "Miner Zombie",
    map: "Dead Mine II",
    town: "El Nath",
    tour_order: 126,
  },
  {
    name: "Dark Stone Golem",
    map: "Golem's Temple III",
    town: "Henesys",
    tour_order: 8,
  },
  {
    name: "White Fang",
    map: "Icy Cold Field",
    town: "El Nath",
    tour_order: 109,
  },
  {
    name: "Reindeer",
    map: "Peach Farm 2",
    town: "Mu Lung",
    tour_order: 305,
  },
  {
    name: "Neo Huroid",
    map: "Lab - Area C-3",
    town: "Magatia",
    tour_order: 280,
  },
  {
    name: "Mixed Golem",
    map: "Golem's Temple IV",
    town: "Henesys",
    tour_order: 9,
  },
  {
    name: "Red Drake",
    map: "Dangerous Valley II",
    town: "Perion",
    tour_order: 40,
  },
  {
    name: "Pepe",
    map: "The Crown-Flyer",
    town: "El Nath",
    tour_order: 108,
  },
  {
    name: "Morphed Blin",
    map: "Top of Black Mountain",
    town: "Korean Folk Town",
    tour_order: 163,
  },
  {
    name: "Panda",
    map: "Wild Bear Area 3",
    town: "Mu Lung",
    tour_order: 297,
  },
  {
    name: "Shade",
    map: "Line 1 <Area 4>",
    town: "Kerning City",
    tour_order: 47,
  },
  {
    name: "Master Dummy",
    map: "Practice Field : Beginner",
    town: "Mu Lung",
    tour_order: 287,
  },
  {
    name: "Tree Rod",
    map: "Western Region of Mossy Tree Forest 2",
    town: "Altaire Camp",
    tour_order: 168,
  },
  {
    name: "Mossy Mushroom",
    map: "Mushroom Hill Entrance",
    town: "Altaire Camp",
    tour_order: 171,
  },
  {
    name: "Primitive Boar",
    map: "Boulder Mountain Entrance",
    town: "Altaire Camp",
    tour_order: 172,
  },
  {
    name: "Stone Bug",
    map: "Souther Region of Mossy Tree Forest 1",
    town: "Altaire Camp",
    tour_order: 169,
  },
  {
    name: "Emo Slime",
    map: "Outskirts of Muddy Banks",
    town: "Trend Zone Metropolis",
    tour_order: 393,
  },
  {
    name: "Trucker",
    map: "Suburban Area 2",
    town: "CBD",
    tour_order: 374,
  },
  {
    name: "Tippo Red",
    map: "Mysterious Path 1",
    town: "Boat Quay Town",
    tour_order: 385,
  },
  {
    name: "Dark Fission",
    map: "Muddy Banks 1",
    town: "Trend Zone Metropolis",
    tour_order: 394,
  },
  {
    name: "Tippo Blue",
    map: "Mysterious Path 1",
    town: "Boat Quay Town",
    tour_order: 385,
  },
  {
    name: "Oly Oly",
    map: "Muddy Banks 1",
    town: "Trend Zone Metropolis",
    tour_order: 394,
  },
  {
    name: "Pac Pinky",
    map: "Ghost ship 1",
    town: "Boat Quay Town",
    tour_order: 388,
  },
  {
    name: "Scaredy Scarlion",
    map: "Hibiscus Road 2",
    town: "Kampung Village",
    tour_order: 398,
  },
  {
    name: "Ratatula",
    map: "Hibiscus Road 2",
    town: "Kampung Village",
    tour_order: 398,
  },
  {
    name: "Selkie Jr.",
    map: "Ghost Ship 5",
    town: "Boat Quay Town",
    tour_order: 390,
  },
  {
    name: "Nightghost",
    map: '"Cemetery Full of Ghosts" "A Desolate Cemetery"',
    town: "Mushroom Shrine",
    tour_order: 412,
  },
  {
    name: "Water Goblin",
    map: "Vanished Village",
    town: "Mushroom Shrine",
    tour_order: 409,
  },
  {
    name: "Extra B",
    map: "Showa Street 1",
    town: "Showa",
    tour_order: 416,
  },
  {
    name: "Extra C",
    map: "Showa Street 2",
    town: "Showa",
    tour_order: 417,
  },
  {
    name: "Chunin",
    map: "Ninja Castle Hallway [3]",
    town: "Ninja Castle",
    tour_order: 428,
  },
  {
    name: "Kunoichi",
    map: "Ninja Castle Hallway [4]",
    town: "Ninja Castle",
    tour_order: 429,
  },
  {
    name: "Buffy",
    map: "Warped Path of Time<1>",
    town: "Ludibrium",
    tour_order: 196,
  },
  {
    name: "Wild Kargo",
    map: "Wild Cargo's Area",
    town: "Sleepywood",
    tour_order: 63,
  },
  {
    name: "Peach Monkey",
    map: "Peach Farm1",
    town: "Mu Lung",
    tour_order: 300,
  },
  {
    name: "Officer Skeleton",
    map: "Camp 3",
    town: "Perion",
    tour_order: 37,
  },
  {
    name: "Soul Teddy",
    map: "Forgotten Path of Time<1>",
    town: "Ludibrium",
    tour_order: 203,
  },
  {
    name: "Jr. Lucida",
    map: "Stairway to the Sky II",
    town: "Orbis",
    tour_order: 91,
  },
  {
    name: "Ice Drake",
    map: "Cold Cradle",
    town: "Sleepywood",
    tour_order: 65,
  },
  {
    name: "Dark Pepe",
    map: "Sharp Cliff II",
    town: "El Nath",
    tour_order: 114,
  },
  {
    name: "Mr. Alli",
    map: "Isolated Swamp",
    town: "Herb Town",
    tour_order: 317,
  },
  {
    name: "Yeti",
    map: "Valley of Snowman",
    town: "El Nath",
    tour_order: 111,
  },
  {
    name: "Riche",
    map: "Forest of Dead Trees I & II & II & IV",
    town: "El Nath",
    tour_order: 123,
  },
  {
    name: "Homun",
    map: "Lab - Unit 201",
    town: "Magatia",
    tour_order: 275,
  },
  {
    name: "Lazy Buffy",
    map: "Warped Path of Time<1>",
    town: "Ludibrium",
    tour_order: 196,
  },
  {
    name: "Sage Cat",
    map: "Goblin Forest 1",
    town: "Mu Lung",
    tour_order: 303,
  },
  {
    name: "Master Soul Teddy",
    map: "Forgotten Path of Time<1>",
    town: "Ludibrium",
    tour_order: 203,
  },
  {
    name: "Dark Drake",
    map: "Drake's Nest",
    town: "Sleepywood",
    tour_order: 66,
  },
  {
    name: "Dark Yeti",
    map: '"Sharp Cliff II" "Dangerous Cliff"',
    town: "El Nath",
    tour_order: 117,
  },
  {
    name: "Kru",
    map: "Red-Nose Pirate Den 1",
    town: "Herb Town",
    tour_order: 314,
  },
  {
    name: "Site",
    map: "Authorized Personnel Only",
    town: "Magatia",
    tour_order: 282,
  },
  {
    name: "Klock",
    map: "Forgotten Path of Time<2>",
    town: "Ludibrium",
    tour_order: 204,
  },
  {
    name: "Tauromacis",
    map: "Sanctuary Entrance IV",
    town: "Sleepywood",
    tour_order: 69,
  },
  {
    name: "Yellow King Goblin",
    map: "Haunted House",
    town: "Korean Folk Town",
    tour_order: 164,
  },
  {
    name: "Blue King Goblin",
    map: "Haunted House",
    town: "Korean Folk Town",
    tour_order: 164,
  },
  {
    name: "Green King Goblin",
    map: "Haunted House",
    town: "Korean Folk Town",
    tour_order: 164,
  },
  {
    name: "Rash",
    map: "West Leafre Forest",
    town: "Leafre",
    tour_order: 318,
  },
  {
    name: "Captain",
    map: "Red-Nose Pirate Den 3",
    town: "Herb Town",
    tour_order: 316,
  },
  {
    name: "Cerebes",
    map: "The Cave of Trial II",
    town: "El Nath",
    tour_order: 130,
  },
  {
    name: "Beetle",
    map: "Leafre : East Forest",
    town: "Leafre",
    tour_order: 330,
  },
  {
    name: "Hobi",
    map: "Cranky Forest",
    town: "Leafre",
    tour_order: 321,
  },
  {
    name: "Commander Skeleton",
    map: "Remains <Cliff>",
    town: "Perion",
    tour_order: 38,
  },
  {
    name: "Lucida",
    map: "Hall of Mushroom",
    town: "Mushroom Shrine",
    tour_order: 414,
  },
  {
    name: "Homunculus",
    map: "Lab - Unit 203",
    town: "Magatia",
    tour_order: 277,
  },
  {
    name: "Buffoon",
    map: "Warped Path of Time<2>",
    town: "Ludibrium",
    tour_order: 197,
  },
  {
    name: "Dark Rash",
    map: "Peach Monkey Forest",
    town: "Leafre",
    tour_order: 320,
  },
  {
    name: "D. Roy",
    map: "Lab - Area C-3",
    town: "Magatia",
    tour_order: 280,
  },
  {
    name: "Werewolf",
    map: "Wolf Territory I & II",
    town: "El Nath",
    tour_order: 118,
  },
  {
    name: "Taurospear",
    map: "Sanctuary Entrance IV",
    town: "Sleepywood",
    tour_order: 69,
  },
  {
    name: "Snow Witch",
    map: "Icy Cold Field",
    town: "El Nath",
    tour_order: 109,
  },
  {
    name: "Security Camera",
    map: "Authorized Personnel Only",
    town: "Magatia",
    tour_order: 282,
  },
  {
    name: "Scholar Ghost",
    map: "Fox Ridge",
    town: "Korean Folk Town",
    tour_order: 161,
  },
  {
    name: "Rurumo",
    map: "Lab - Area B-3, B-1, C-2",
    town: "Magatia",
    tour_order: 281,
  },
  {
    name: "Rodeo",
    map: "Muddy Banks 2",
    town: "Trend Zone Metropolis",
    tour_order: 395,
  },
  {
    name: "Slimy",
    map: "Ghost Ship 2",
    town: "Boat Quay Town",
    tour_order: 389,
  },
  {
    name: "Charmer",
    map: "Muddy Banks 3",
    town: "Trend Zone Metropolis",
    tour_order: 396,
  },
  {
    name: "Mr. Anchor",
    map: "Ghost Ship 6",
    town: "Boat Quay Town",
    tour_order: 391,
  },
  {
    name: "Jester Scarlion",
    map: "Longest Ride on ByeBye Station",
    town: "Kampung Village",
    tour_order: 402,
  },
  {
    name: "Froscola",
    map: "Longest Ride on ByeBye Station",
    town: "Kampung Village",
    tour_order: 402,
  },
  {
    name: "Yabber Doo",
    map: "Fantasy Theme Park 2",
    town: "Kampung Village",
    tour_order: 400,
  },
  {
    name: "Extra D",
    map: "Parking Lot",
    town: "Showa",
    tour_order: 420,
  },
  {
    name: "Leader A",
    map: "Finance of Flaming Raccoon",
    town: "Showa",
    tour_order: 421,
  },
  {
    name: "Leader B",
    map: "Parking Lot",
    town: "Showa",
    tour_order: 420,
  },
  {
    name: "Dark Klock",
    map: "Forgotten Path of Time<2>",
    town: "Ludibrium",
    tour_order: 204,
  },
  {
    name: "Dual Beetle",
    map: "Minar Forest : East Border",
    town: "Leafre",
    tour_order: 328,
  },
  {
    name: "Green Hobi",
    map: "Steep Hill",
    town: "Leafre",
    tour_order: 322,
  },
  {
    name: "Deep Buffoon",
    map: "Warped Path of Time<2>",
    town: "Ludibrium",
    tour_order: 197,
  },
  {
    name: "Yeti and Pepe",
    map: "Ice Valley II",
    town: "El Nath",
    tour_order: 112,
  },
  {
    name: "Hankie",
    map: "Steep Hill",
    town: "Leafre",
    tour_order: 322,
  },
  {
    name: "Lycanthrope",
    map: "Wolf Territory III & IV & V",
    town: "El Nath",
    tour_order: 118,
  },
  {
    name: "Harp",
    map: "Sky Nest I",
    town: "Leafre",
    tour_order: 326,
  },
  {
    name: "Homunscullo",
    map: "Lab - Unit 202",
    town: "Magatia",
    tour_order: 276,
  },
  {
    name: "Dark Yeti and Pepe",
    map: "Dangerous Cliff",
    town: "El Nath",
    tour_order: 117,
  },
  {
    name: "Ghost Pirate",
    map: "Warped Path of Time<3>",
    town: "Ludibrium",
    tour_order: 198,
  },
  {
    name: "Blood Harp",
    map: "Sky Nest II",
    town: "Leafre",
    tour_order: 325,
  },
  {
    name: "Death Teddy",
    map: "Forgotten Path of Time<3>",
    town: "Ludibrium",
    tour_order: 205,
  },
  {
    name: "Goby",
    map: "Deep Sea Gorge II",
    town: "Aquarium",
    tour_order: 149,
  },
  {
    name: "Birk",
    map: "Forest : Crossroad",
    town: "Leafre",
    tour_order: 323,
  },
  {
    name: "Dual Ghost Pirate",
    map: "Unbalanced Time",
    town: "Ludibrium",
    tour_order: 199,
  },
  {
    name: "Black Kentaurus",
    map: "The Area of Black Kentaurus",
    town: "Leafre",
    tour_order: 332,
  },
  {
    name: "Red Kentaurus",
    map: "The Area of Red Kentaurus",
    town: "Leafre",
    tour_order: 335,
  },
  {
    name: "Blue Kentaurus",
    map: "The Area of Blue Kentaurus",
    town: "Leafre",
    tour_order: 332,
  },
  {
    name: "Dual Birk",
    map: "Forest : Crossroad",
    town: "Leafre",
    tour_order: 323,
  },
  {
    name: "Master Death Teddy",
    map: "Lost Time",
    town: "Ludibrium",
    tour_order: 206,
  },
  {
    name: "Bain",
    map: "Armory",
    town: "Showa",
    tour_order: 423,
  },
  {
    name: "Blue Dragon Turtle",
    map: "Entrance to Dragon Forest",
    town: "Leafre",
    tour_order: 339,
  },
  {
    name: "Deet and Roi",
    map: "Lab - Unit 202",
    town: "Magatia",
    tour_order: 276,
  },
  {
    name: "Eye of Time",
    map: "Memory Lane 5",
    town: "Three Doors",
    tour_order: 361,
  },
  {
    name: "Booper Scarlion",
    map: "Fantasy Theme Park 2",
    town: "Kampung Village",
    tour_order: 400,
  },
  {
    name: "Berserkie",
    map: "Ulu City Entrance",
    town: "CBD",
    tour_order: 375,
  },
  {
    name: "Vikerola",
    map: "Fantasy Theme Park 3",
    town: "Kampung Village",
    tour_order: 401,
  },
  {
    name: "Veetron",
    map: "Ulu Estate I",
    town: "CBD",
    tour_order: 376,
  },
  {
    name: "Black Bear Swordsman",
    map: "Foot of the Mountain",
    town: "Mount Song Town",
    tour_order: 445,
  },
  {
    name: "White Tiger Swordsman",
    map: "Foot of the Mountain",
    town: "Mount Song Town",
    tour_order: 445,
  },
  {
    name: "Bone Fish",
    map: "Deep Sea Gorge I",
    town: "Aquarium",
    tour_order: 148,
  },
  {
    name: "Red Dragon Turtle",
    map: "The Hidden Dragon Tomb I",
    town: "Leafre",
    tour_order: 340,
  },
  {
    name: "Spirit Viking",
    map: "Warped Path of Time<4>",
    town: "Ludibrium",
    tour_order: 200,
  },
  {
    name: "Squid",
    map: "Dangerous Sea Gorge I",
    town: "Aquarium",
    tour_order: 150,
  },
  {
    name: "Phantom Watch",
    map: "Forgotten Path of Time<4>",
    town: "Ludibrium",
    tour_order: 207,
  },
  {
    name: "Rexton",
    map: "Dragon Forest II",
    town: "Leafre",
    tour_order: 344,
  },
  {
    name: "Brexton",
    map: "Dragon Forest III",
    town: "Leafre",
    tour_order: 345,
  },
  {
    name: "Risell Squid",
    map: "Dangerous Sea Gorge II",
    town: "Aquarium",
    tour_order: 151,
  },
  {
    name: "Red Wyvern",
    map: "Red Wyvern's Nest",
    town: "Leafre",
    tour_order: 348,
  },
  {
    name: "Gigantic Spirit Viking",
    map: "Twisted Time",
    town: "Ludibrium",
    tour_order: 201,
  },
  {
    name: "Grim Phantom Watch",
    map: "Forbidden Time",
    town: "Ludibrium",
    tour_order: 208,
  },
  {
    name: "Green Cornian",
    map: "The Burning Forest",
    town: "Leafre",
    tour_order: 342,
  },
  {
    name: "Shark",
    map: "The Grave of a Wrecked Ship",
    town: "Aquarium",
    tour_order: 152,
  },
  {
    name: "Blue Wyvern",
    map: "Blue Wyvern's Nest",
    town: "Leafre",
    tour_order: 350,
  },
  {
    name: "Cold Shark",
    map: "The Grave of a Wrecked Ship",
    town: "Aquarium",
    tour_order: 152,
  },
  {
    name: "Dark Wyvern",
    map: "Canyon : East Road",
    town: "Leafre",
    tour_order: 349,
  },
  {
    name: "Dark Cornian",
    map: "The Burning Forest",
    town: "Leafre",
    tour_order: 342,
  },
  {
    name: "Jr. Newtie",
    map: "Destroyed Dragon Nest",
    town: "Leafre",
    tour_order: 353,
  },
  {
    name: "Memory Monk",
    map: "Memory Lane 1",
    town: "Three Doors",
    tour_order: 358,
  },
  {
    name: "Memory Monk Trainee",
    map: "Memory Lane 2",
    town: "Three Doors",
    tour_order: 359,
  },
  {
    name: "Memory Guardian",
    map: "Memory Lane 3",
    town: "Three Doors",
    tour_order: 360,
  },
  {
    name: "Chief Memory Guardian",
    map: "Memory Lane 5",
    town: "Three Doors",
    tour_order: 361,
  },
  {
    name: "Montrecer",
    map: "Ulu Estate III",
    town: "CBD",
    tour_order: 378,
  },
  {
    name: "Slygie",
    map: "Ulu Estate II",
    town: "CBD",
    tour_order: 377,
  },
  {
    name: "Gallopera",
    map: "Entrance to the Spooky World",
    town: "Kampung Village",
    tour_order: 403,
  },
  {
    name: "Wooden Fish",
    map: "Sutra Depository 7 F",
    town: "Shaolin Temple Main Hall",
    tour_order: 453,
  },
  {
    name: "Censer",
    map: "Shaolin Temple Square",
    town: "Mount Song Town",
    tour_order: 448,
  },
  {
    name: "Female Thief",
    map: "Mountainside",
    town: "Mount Song Town",
    tour_order: 447,
  },
  {
    name: "Male Thief",
    map: "Mountainside",
    town: "Mount Song Town",
    tour_order: 447,
  },
  {
    name: "Eagle Swordsman",
    map: "Mountain Path 1",
    town: "Mount Song Town",
    tour_order: 446,
  },
  {
    name: "Dreamy Ghost",
    map: "Encounter with the Buddha",
    town: "Mushroom Shrine",
    tour_order: 410,
  },
  {
    name: "Male Boss",
    map: "Armory",
    town: "Showa",
    tour_order: 423,
  },
  {
    name: "Ninto",
    map: "Ninja Castle Hallway [8]",
    town: "Ninja Castle",
    tour_order: 432,
  },
  {
    name: "Gatekeeper",
    map: "Warpped Passage",
    town: "Ludibrium",
    tour_order: 202,
  },
  {
    name: "Thanatos",
    map: "Forgotten Passage",
    town: "Ludibrium",
    tour_order: 209,
  },
  {
    name: "Skelegon",
    map: "Nest of a Dead Dragon",
    town: "Leafre",
    tour_order: 355,
  },
  {
    name: "Skelosaurus",
    map: "The Dragon Nest Left Behind",
    town: "Leafre",
    tour_order: 356,
  },
  {
    name: "Nest Golem",
    map: "Dangerous Dragon Nest",
    town: "Leafre",
    tour_order: 354,
  },
  {
    name: "Qualm Monk",
    map: "Road of Regrets 1",
    town: "Three Doors",
    tour_order: 362,
  },
  {
    name: "Qualm Monk Trainee",
    map: "Road of Regrets 2",
    town: "Three Doors",
    tour_order: 363,
  },
  {
    name: "Qualm Guardian",
    map: "Road of Regrets 3",
    town: "Three Doors",
    tour_order: 364,
  },
  {
    name: "Chief Qualm Guardian",
    map: "Road of Regrets 5",
    town: "Three Doors",
    tour_order: 365,
  },
  {
    name: "Oblivion Monk",
    map: "Road to Oblivion 1",
    town: "Three Doors",
    tour_order: 366,
  },
  {
    name: "Oblivion Monk Trainee",
    map: "Road to Oblivion 2",
    town: "Three Doors",
    tour_order: 367,
  },
  {
    name: "Oblivion Guardian",
    map: "Road to Oblivion 3",
    town: "Three Doors",
    tour_order: 368,
  },
  {
    name: "Chief Oblivion Guardian",
    map: "Road to Oblivion 5",
    town: "Three Doors",
    tour_order: 369,
  },
  {
    name: "Petrifighter",
    map: "Ulu City Center",
    town: "CBD",
    tour_order: 380,
  },
  {
    name: "Duku",
    map: "Destroyed Park II",
    town: "CBD",
    tour_order: 382,
  },
  {
    name: "Silver Spearman",
    map: "Sutra Depository 5-6 F",
    town: "Shaolin Temple Main Hall",
    tour_order: 452,
  },
  {
    name: "Bronze Staffman",
    map: "Sutra Depository 1-2 F",
    town: "Shaolin Temple Main Hall",
    tour_order: 450,
  },
  {
    name: "Silver Giant",
    map: "Sutra Depository 7 F",
    town: "Shaolin Temple Main Hall",
    tour_order: 453,
  },
  {
    name: "Golden Giant",
    map: "Sutra Depository 7 F",
    town: "Shaolin Temple Main Hall",
    tour_order: 453,
  },
  {
    name: "Mini Bronze Martial Artist",
    map: "Sutra Depository 1-2 F",
    town: "Shaolin Temple Main Hall",
    tour_order: 450,
  },
  {
    name: "Mini Gold Martial Artist",
    map: "Sutra Depository 5-6 F",
    town: "Shaolin Temple Main Hall",
    tour_order: 452,
  },
  {
    name: "Afterroad",
    map: "2100 Odaiba [1]",
    town: "Neo Tokyo",
    tour_order: 435,
  },
  {
    name: "Overload",
    map: "2095 Park [1]",
    town: "Neo Tokyo",
    tour_order: 437,
  },
  {
    name: "Protoroad",
    map: "2095 Park [1]",
    town: "Neo Tokyo",
    tour_order: 437,
  },
  {
    name: "Maverick A",
    map: "2095 Park [4]",
    town: "Neo Tokyo",
    tour_order: 438,
  },
  {
    name: "Maverick Y",
    map: "2095 Park [4]",
    town: "Neo Tokyo",
    tour_order: 438,
  },
  {
    name: "Eruwater",
    map: "2102 Akihabara - Rooftop",
    town: "Neo Tokyo",
    tour_order: 440,
  },
  {
    name: "Maverick B",
    map: "2095 Park [4]",
    town: "Neo Tokyo",
    tour_order: 438,
  },
  {
    name: "Maverick V",
    map: "2102 Old Fox Flagship Deck [1]",
    town: "Neo Tokyo",
    tour_order: 442,
  },
  {
    name: "Jiaoceng",
    map: "Shaolin Secret Chamber",
    town: "Shaolin Temple Main Hall",
    tour_order: 454,
  },
  {
    name: "Mano",
    map: "Thicket Around the Beach III",
    town: "Lith Harbor",
    tour_order: 1,
  },
  {
    name: "King Slime (PC)",
    map: "1st Accompaniment <Last Stage>",
    town: "Kerning City (Party Quest)",
    tour_order: 999,
  },
  {
    name: "Faust",
    map: "The Forest of Evil I",
    town: "Ellinia",
    tour_order: 14,
  },
  {
    name: "King Clang",
    map: "Hot Sand",
    town: "Florina Beach",
    tour_order: 75,
  },
  {
    name: "Alishar",
    map: "A Crack on the Wall",
    town: "Ludibrium (Party Quest)",
    tour_order: 999,
  },
  {
    name: "Timer",
    map: "Whirlpool of Time",
    town: "Ludibrium",
    tour_order: 193,
  },
  {
    name: "Mushmom",
    map: "Someone Else's House",
    town: "Henesys",
    tour_order: 6,
  },
  {
    name: "Dyle",
    map: "Dangerous Croko I",
    town: "Kerning City",
    tour_order: 53,
  },
  {
    name: "Zombie Mushroom",
    map: "The Grave of Mushmom",
    town: "Sleepywood",
    tour_order: 59,
  },
  {
    name: "Old Fox",
    map: "Moon Ridge",
    town: "Korean Folk Town",
    tour_order: 162,
  },
  {
    name: "Tae Roon",
    map: "Territory of Wandering Bear",
    town: "Mu Lung",
    tour_order: 298,
  },
  {
    name: "Lord Pirate",
    map: "The Captain's Dignity",
    town: "Herb Town (Party Quest)",
    tour_order: 999,
  },
  {
    name: "Papa Pixie",
    map: "Tower of Goddess <Walkway>",
    town: "Orbis (Party Quest)",
    tour_order: 999,
  },
  {
    name: "King Sage Cat",
    map: "Goblin Forest 2",
    town: "Mu Lung",
    tour_order: 304,
  },
  {
    name: "Elliza",
    map: "Stairway to the Sky II",
    town: "Orbis",
    tour_order: 91,
  },
  {
    name: "Snowman",
    map: "Valley of Snowman",
    town: "El Nath",
    tour_order: 111,
  },
  {
    name: "Crimson Balrog",
    map: '"To Orbis", "To Ellinia"',
    town: "N/A",
    tour_order: 999,
  },
  {
    name: "Manon",
    map: "Manon's Forest",
    town: "Leafre",
    tour_order: 338,
  },
  {
    name: "Griffey",
    map: "Griffey Forest",
    town: "Leafre",
    tour_order: 334,
  },
  {
    name: "Pianus (R)",
    map: "The Cave of Pianus",
    town: "Aquarium",
    tour_order: 154,
  },
  {
    name: "Ergoth",
    map: "Ergoth's Throne",
    town: "Perion (Party Quest)",
    tour_order: 999,
  },
  {
    name: "Papulatus",
    map: "Origin of Clocktower",
    town: "Ludibrium",
    tour_order: 210,
  },
  {
    name: "Zakum3",
    map: "Zakum's Altar",
    town: "El Nath",
    tour_order: 132,
  },
  {
    name: "Horntail",
    map: "Cave of Life",
    town: "Leafre",
    tour_order: 357,
  },
  {
    name: "Stumpy",
    map: "East Rocky Mountain V",
    town: "Perion",
    tour_order: 26,
  },
  {
    name: "Jr. Balrog",
    map: "The Cursed Sanctuary",
    town: "Sleepywood",
    tour_order: 70,
  },
  {
    name: "Deo",
    map: "Royal Cactus Desert",
    town: "Ariant",
    tour_order: 253,
  },
  {
    name: "Seruf",
    map: "The Seaweed Tower",
    town: "Aquarium",
    tour_order: 140,
  },
  {
    name: "Zeno",
    map: "Gray's Prairie",
    town: "Omega Sector",
    tour_order: 247,
  },
  {
    name: "Kimera",
    map: "Secret Basement Path",
    town: "Magatia",
    tour_order: 286,
  },
  {
    name: "Leviathan",
    map: "Leviathan's Canyon",
    town: "Leafre",
    tour_order: 351,
  },
  {
    name: "Dodo",
    map: "Memory Lane 5",
    town: "Three Doors",
    tour_order: 361,
  },
  {
    name: "Lilynouch",
    map: "Road of Regrets 5",
    town: "Three Doors",
    tour_order: 365,
  },
  {
    name: "Lyka",
    map: "Road to Oblivion 5",
    town: "Three Doors",
    tour_order: 369,
  },
  {
    name: "Super Charged Poison Golem",
    map: "Forest of Poison",
    town: "Altaire Camp (Party Quest)",
    tour_order: 449,
  },
  {
    name: "Capt. Latanica",
    map: "Engine Room",
    town: "Boat Quay Town",
    tour_order: 392,
  },
  {
    name: "Furious Targa",
    map: "Spooky World",
    town: "Kampung Village",
    tour_order: 404,
  },
  {
    name: "Furious Scarlion Boss",
    map: "Spooky World",
    town: "Kampung Village",
    tour_order: 404,
  },
  {
    name: "Black Crow",
    map: "Encounter with the Buddha",
    town: "Mushroom Shrine",
    tour_order: 410,
  },
  {
    name: "Female Boss",
    map: "Parlor",
    town: "Showa",
    tour_order: 422,
  },
  {
    name: "The Boss",
    map: "The Nightmarish Last Day",
    town: "Showa",
    tour_order: 424,
  },
  {
    name: "Castellan",
    map: "Tower Room",
    town: "Ninja Castle",
    tour_order: 434,
  },
  {
    name: "Vergamot",
    map: "2100 Odaiba [4]",
    town: "Neo Tokyo",
    tour_order: 436,
  },
  {
    name: "Nameless Magic Monster",
    map: "Kamuna [3]",
    town: "Neo Tokyo",
    tour_order: 444,
  },
  {
    name: "Dunas",
    map: "2102 Shibuya [4]",
    town: "Neo Tokyo",
    tour_order: 436,
  },
  {
    name: "Nibergen",
    map: "2102 Tokyo Skies",
    town: "Neo Tokyo",
    tour_order: 443,
  },
  {
    name: "Krexel",
    map: "Ruins of Krexel II",
    town: "CBD",
    tour_order: 384,
  },
  {
    name: "Franken Lloyd",
    map: "Center Lab",
    town: "Magatia (Party Quest)",
    tour_order: 999,
  },
  {
    name: "Jiaoceng",
    map: "Shaolin Secret Chamber",
    town: "Shaolin Temple Main Hall",
    tour_order: 454,
  },
  {
    name: "Giant Centipede",
    map: '"Shanghai - Northern Flatland", "Western Prairie I"',
    town: "Shanghai",
    tour_order: 999,
  },
];

export { monsters };
